import { boolean } from "yup"
const isUAElogin =   JSON.parse(localStorage.getItem("isUAElogin"));
const isecommerce =   JSON.parse(localStorage.getItem("ecommerce"));
const isbarcode =   JSON.parse(localStorage.getItem("enablebarcoding"));
const isRestaurentPOSEnabled = JSON.parse(localStorage.getItem("userDetails"))?.isRestaurantPOS === "True" ? true : false
export const supplyConfig = [
     
    {
        ctrltype: "switch",
        name: 'enablebarcoding',
        label: 'Enable Barcode',
        value: false,
        isPremium:true,
        PremiumName:'barCode'
    },
    // {
    //     ctrltype: "switch",
    //     name: 'enablebatches',
    //     label: 'Enable Batches',
    //     value: false,
    // },
    
    {
        ctrltype: "switch",
        name: 'enableserialization',
        label: 'Enable Serialization',
        isPremium:true,
        value: false,
         PremiumName:'serialNumber'
    },
    // {
    //     ctrltype: "switch",
    //     name: 'enableshelflife',
    //     label: 'Enable Shelf Life',
    //     value: false,
    // },
   
    {
        ctrltype: "switch",
        name: 'enablevariants',
        label: 'Enable Variants Based SKU',
        value: false,
    },
          {
       ctrltype: "switch",
        name: 'salesmanTagging',
        label: 'SalesMan Tagging',
        value: false, 
    },
        {
       ctrltype: "switch",
        name: 'invValuations',
        label: 'Stock Valuation',
        value: false, 
    },
     {
       ctrltype: "switch",
        name: 'enableBatch',
        label: 'Batch / Lot No',
        value: false, 
    },
    {
       ctrltype: "switch",
        name: 'isRelatedProducts',
        label: 'Related Products',
        value: false, 
    },

    {
       ctrltype: "switch",
        name: 'isBundle',
        label: 'Product Bundle',
        value: false, 
    },
   
    {
        ctrltype: "switch",
        name: 'ecommerce',
        label: 'E-Commerce',
        value: false,
    },

   {
        ctrltype: "switch",
        name: 'enableMulticurrency',
        label: 'Enable Multi currency',
        value: false,
    },
    //  {
    //     ctrltype: "switch",
    //     name: 'enableStockValuation',
    //     label: 'Enable Stock Valuation',
    //     value: false,
    // },
        {
        typectrl: "drp",
        ctrltype: "dropdown",
        placeHolder: "Select Industry",
        isRequired: true,
        errormsg: false,
        // disabled: localStorage.getItem('industryType') !== 'null' ?true:false,
        label: "Industry Type:",
        name: "industryType",
        key: '',
        tooltip: 'Please Select the Currency Code',
        isTooltip: true,
        Option: [ { key: "Food & Beverages" , text: "Food & Beverages" }, 
                  { key:"E-commerce", text: "E-commerce" }, 
                  { key: "Jewellery", text: "Jewellery" }, 
                  { key: "Diamond", text: "Diamond" },
               ],
    },
    {
        ctrltype: "switch",
        name: 'isWeighingScale',
        label: "Weighing Scale",
        value: false,
    },
    {
        ctrltype: "switch",
        name: 'isMultiUOM',
        label: "Multi UOM",
        value: false,
    },
     {
        ctrltype: "switch",
        name: 'isPurchaseBarcode',
        label: "Purchase Barcode",
        value: false,
    },

      {
        ctrltype: "switch",
        name: 'paymentAlerts',
        label: "PaymentAlerts",
        value: false,
    },
{
  typectrl: "txt",
  ctrltype: "text",
  label: "Alert In Days",
  disabled: false,
  name: "alertsInDays",
  value: "",
  type: "text",
  placeholder: "",
  isRequired: true,
  errormsg: false,
  multiline: false,
  rows: 3,
  
},
{
  typectrl: "txt",
  ctrltype: "text",
  label: "Overdue Days",
  disabled: false,
  name: "overdueInDays",
  value: "",
  type: "text",
  placeholder: "",
  isRequired: true,
  errormsg: false,
  multiline: false,
  rows: 3,
  
}
].filter(Boolean)

export const inventoryConfig = [
    {
        ctrltype: "switch",
        name: 'inventoryTracking',
        label: 'Track Inventory',
        value: false,
        disabled: false,
    },
    {
        ctrltype: "switch",
        name: 'isAllowNegative',
        label: 'Allow Negative Quantity',
        value: false,
    },
    //  isUAElogin === false && 
    {
        ctrltype: "switch",
        name: 'isWarehouse',
        label: 'Stock Room',
        value: false,
        disabled: false,
          isPremium:true,
         PremiumName:'stockRooms'
    }
].filter(Boolean)
export const tCSSettingConfig = [
    {
        ctrltype: "switch",
        name: 'isTDSApplicable',
        label: 'TDS Applicable',
        value: false,
        disabled: false,
    },
    {
        ctrltype: "switch",
        name: 'isTCSApplicable',
        label: 'TCS Applicable',
        value: false,
    }
]

export const invoicingSub = [
    {
        ctrltype: "switch",
        name: 'isRoundOffTotals',
        label: 'Round off in Transactions',
        value: false,
    },
    // {
    //     ctrltype: "switch",
    //     name: 'tdsadjustments',
    //     label: 'Tds Adjustments',
    //     value: false,
    // },
    {
        ctrltype: "switch",
        name: 'otherAdjustments',
        label: 'Other Adjustments',
        value: false,
    }
]

export const genConfigSub = [
    {
        typectrl: "drp",
        ctrltype: "dropdown",
        placeHolder: "₹ ",
        isRequired: true,
        errormsg: false,
        disabled: false,
        label: "Select Currency:",
        name: "currencyCode",
        key: 1,
        tooltip: 'Please Select the Currency Code',
        isTooltip: true,
        Option: [],
    },
    {
        typectrl: "drp",
        ctrltype: "dropdown",
        placeHolder: "DD-MM-YYYY ",
        isRequired: true,
        errormsg: false,
        disabled: false,
        label: "Date Format:",
        name: "dateFormat",
        tooltip: 'Please Select the Date Format',
        isTooltip: true,
        key: 2,
        Option: [
            { key: 2, text: "DD-MM-YYYY" },
            // { key: 1, text: "MM-DD-YYYY" },
        ],
    },
]

export const accountingSub = [
    {
        ctrltype: "switch",
        name: 'lockprev',
        label: 'Lock Previous Year',
        value: false,
    },
    {
        typectrl: "drp",
        ctrltype: "dropdown",
        placeHolder: "select ",
        isRequired: true,
        errormsg: false,
        label: "Date:",
        name: "prevfinancialdate",
        tooltip: 'Please Select the Date Range',
        isTooltip: true,
        key: '',
        Option: [
            { key: 1, text: "2022-2023", start: "01-04-2022", end: "31-03-2023" },
            { key: 2, text: "2021-2022", start: "01-04-2021", end: "31-03-2022" },
            { key: 3, text: "2020-2021", start: "01-04-2020", end: "31-03-2021" },
            { key: 4, text: "2019-2020", start: "01-04-2019", end: "31-03-2020" },
            { key: 5, text: "2018-2019", start: "01-04-2018", end: "31-03-2019" },
        ],
    },

]

export const configMenus = [
    {
        key: 'sub1',
        name: 'General Configurations',
        menuitems: [
            {
                key: "Config General",
                name: 'General'
            },
            {
                key: "1",
                name: 'Number Series'
            },
            // isUAElogin === false && 
            {
                key: "2",
                name: 'Additional Config'
            },
            {
                key: "termsMaster",
                name: 'Terms & Conditions'
            },
            isUAElogin === false && 
            {
                key: "businessType",
                name: 'Business Type'
            },

        ].filter(Boolean)
    },

    {
        key: 'sub2',
        name: 'Masters',
        menuitems: [
            
            {
                key: "Config Masters",
                name: 'Item Configuration'
            },
            {
                key: "bankDetails",
                name: 'Bank Details'
            },
        ]
    },
    {
        key: 'sub9',
        name: 'Transaction Settings',
        menuitems: [
            {
                key: "Settings",
                name: 'Transaction Settings'
            },
        ]
    },
    {
        key: 'sub3',
        name: 'Invoicing',
        menuitems: [
            {
                key: "Config Invoicing",
                name: 'Adjustments'
            },
             isUAElogin === false && 
            {
                key: "5",
                name: 'Invoice Builder'
            }
        ].filter(Boolean)
    },
    {
        key: 'sub4',
        name: 'Inventory',
        menuitems: [
            {
                key: "Config Inventory",
                name: 'Inventory'
            },
        ]
    },
    // {
    //     key: 'sub5',
    //     name: 'Themes',
    //     menuitems: [
    //         {
    //             key: "Config Themes",
    //             name: 'Themes'
    //         }
    //     ]
    // },
    // (isUAElogin === false && process.env.REACT_APP_RUN === 'dev') && {
    //     key: 'sub6',
    //     name: 'Workflow Management',
    //     menuitems: [
    //         {
    //             key: "Config Workflow Management",
    //             name: 'Workflow Management'
    //         }
    //     ]
    // },
    {
        key: 'sub7',
        name: 'E-Invoice ',
        menuitems: [
            {
                key: "Config E-Invoice",
                name: 'IRN Credentials'
            }
        ]
    },
    {
        key: 'sub8',
        name: 'Upload Logo ',
        menuitems: [
            {
                key: "org Logo",
                name: 'Upload Logo'
            }
        ]
    },
    // isecommerce === true &&
    //  {
    //     key: 'sub145',
    //     name: 'SMTP Configuration',
    //     menuitems: [
    //         {
    //             key: "SMTP Configuration",
    //             name: 'SMTP Configuration'
    //         }
    //     ]
    // },
    ...(isecommerce
    ? [
        {
          key: 'sub145',
          name: 'SMTP Configuration',
          menuitems: [
            {
              key: "SMTP Configuration",
              name: 'SMTP Configuration'
            }
          ]
        }
      ]
    : []),
    isecommerce === true &&
    {
        key: 'subStore',
        name: 'Store Settings',
        menuitems: [
            {
                key: "Store Settings",
                name: 'Store Settings'
            }
        ]
    },
     {
        key: 'sub45',
        name: 'Email Template',
        menuitems: [
            {
                key: "Email Template",
                name: 'Email Templates'
            }
        ]
    },
     {
        key: 'sub333',
        name: 'SMS Template',
        menuitems: [
            {
                key: "SMS Template",
                name: 'SMS Templates'
            }
        ]
    },
     {
        key: 'sub098',
        name: 'Site Maps',
        menuitems: [
            {
                key: "Site Maps",
                name: 'SiteMaps And Robots'
            }
        ]
    },
     {
        key: 'sub765',
        name: 'Shipping Settings',
        menuitems: [
            {
                key: "Shipping Settings",
                name: 'Shipping Settings'
            }
        ]
    },
    // {
    //     key: 'sub890',
    //     name: 'WhatsApp Meta',
    //     menuitems: [
    //         {
    //             key: "WhatsApp Meta",
    //             name: 'WhatsApp Meta'
    //         }
    //     ]
    // },
    // {
    //     key: 'sub891',
    //     name: 'Meta WhatsApp Templates',
    //     menuitems: [
    //         {
    //             key: "Meta WhatsApp Templates",
    //             name: 'Meta WhatsApp Templates'
    //         }
    //     ]
    // },
    // {
    //     key: 'sub199',
    //     name: 'Logistic Partner',
    //     menuitems: [
    //         {
    //             key: "Logistic Partner",
    //             name: 'Logistic Partner'
    //         }
    //     ]
    // },
     isbarcode === true &&
    {
        key: 'sub299',
        name: 'Barcode Config',
        flag : JSON.parse(localStorage.getItem("enablebarcoding")),
        menuitems: [
            {
                key: "Barcode Config",
                name: 'Barcode Config'
            }
        ]
    },
    //  isUAElogin === false ?
    // {
    //     key: 'sub99',
    //     name: 'TDS/TCS Setting',
    //     menuitems: [
    //         {
    //             key: "TDS/TCS Setting",
    //             name: 'TDS/TCS Setting'
    //         }
    //     ]
    // }:"",
    //  isUAElogin === false ?
    // {
    //     key: 'sub44',
    //     name: 'Custom Theme',
    //     menuitems: [
    //         {
    //             key: "Custom Theme",
    //             name: 'Custom Theme'
    //         }
    //     ]
    // }:"",
    isUAElogin === true ?
     {
        key: 'sub66',
        name: 'Associate Partner',
        menuitems: [
            {
                key: 'Associate CA',
                name: 'Associate Partner'
            }
        ]
    } : "",
   isUAElogin=== false ?
        {
        key: 'sub190',
        name: 'Payment Gateway',
        menuitems: [
            {
                key: "Payment Gateway",
                name: 'Payment Gateway'
            }
        ]
    }:"",
       isUAElogin=== false ?
        {
        key: 'sub191',
        name: 'SMS Gateway',
        menuitems: [
            {
                key: "SMS Gateway",
                name: 'SMS Gateway'
            }
        ]
    }:"",
    {
        key: 'subPLU',
        name: 'PLU Configuration',
        menuitems: [
            {
                key: "PLU Configuration",
                name: 'PLU Configuration'
            }
        ]
    },
    {
        key: 'sub192',
        name: 'Storage Providers',
        menuitems: [
            {
                key: "Storage Providers",
                name: 'Storage Providers'
            }
        ]
    },
    isRestaurentPOSEnabled && {
        key: 'sub193',
        name: 'Floor Management',
        menuitems: [
            {
                key: "Floor Management",
                name: 'Floor Management'
            }
        ]
    },
    isRestaurentPOSEnabled && {
        key: 'sub194',
        name: 'Table Management',
        menuitems: [
            {
                key: "Table Management",
                name: 'Table Management'
            }
        ]
    }

].filter(Boolean)

export const plucodeForm = [
    {
        typectrl: "txt",
        ctrltype: "text",
        label: "Prefix Length",
        name: "prefixNoOfDigits",
        value: '',
        type: "text",
        placeholder: "",
        isSpecialChar: true,
        isRequired: true,
        maxLength: 2,
        isNumeric: true,
        multiline: false,
        tooltip: 'Prefix for PLU code',
        isTooltip: true,
        rows: 3,
    },
    {
        typectrl: "txt",
        ctrltype: "text",
        label: "Plu Code Length",
        name: "pluNoOfDigits",
        value: '',
        type: "text",
        placeholder: "",
        maxLength: 2,
        isNumeric: true,
        isRequired: true,
        errormsg: false,
        multiline: false,
        tooltip: 'PLU Code Digits',
        isTooltip: true,
        rows: 3,
        isSpecialChar: false,
    },
    {
        typectrl: "txt",
        ctrltype: "text",
        label: "Weight Length",
        name: "weightNoOfDigits",
        value: '',
        type: "number",
          maxLength: 2,
        placeholder: "",
        isRequired: true,
        isNumeric: true,
        errormsg: false,
        multiline: false,
        tooltip: 'Weight value',
        isTooltip: true,
        rows: 3,
    },
    {
        typectrl: "txt",
        ctrltype: "text",
        label: "Check Digit Length",
        name: "checkDigitNoOfDigits",
        value: 1,
        type: "number",
        placeholder: "",
         disabled: true,
        isRequired: true,
        errormsg: false,
        multiline: false,
        maxLength: 1,
        isNumeric: true,
        tooltip: 'Check digit for PLU code',
        isTooltip: true,
        rows: 3,
    },
    {
        typectrl: "txt",
        ctrltype: "primarybtn",
        labels: "",
        type: "primary",
        text: "Save",
        disabled: false,
        id: "plu_savebtn"
    },
    {
        typectrl: "txt",
        ctrltype: "primarybtnu",
        labels: "",
        type: "primary",
        text: "Update",
        disabled: false,
        id: "plu_updatebtn"
    },
    {
        typectrl: "txt",
        ctrltype: "defaultbtn",
        labels: "",
        type: "default",
        text: "Cancel",
        disabled: false,
        id: "plu_cancelbtn"
    },
]

export const actionbtns = [
    {
        ctrltype: "btn",
        labels: "",
        type: "default",
        name: "draft",
        hidden: false,
        text: "Save as Draft",
        isDisabled: false,
        id: 'oms_draft_btn',
    },
    {
        ctrltype: "btn",
        labels: "",
        type: "primary",
        name: "update",
        hidden: true,
        text: "Update",
        isDisabled: false,
        id: 'oms_draft_btn',
    },
    {
        ctrltype: "btn",
        labels: "",
        type: "primary",
        hidden: false,
        name: "publish",
        text: "Publish",
        isDisabled: false,
        id: 'oms_publish_btn',
    },
    {
        ctrltype: "btn",
        labels: "",
        type: "default",
        hidden: false,
        name: "cancel",
        text: "Cancel",
        isDisabled: false,
        id: 'oms_cancel_btn',
    },
];

export const statusbtns = [
    // {
    //     ctrltype: "btn",
    //     labels: "",
    //     type: "default",
    //     hidden: false,
    //     name: "default",
    //     text: "Default",
    //     isDisabled: false,
    //     id: 'oms_setdefault_btn',
    // },
    {
        ctrltype: "btn",
        labels: "",
        type: "primary",
        hidden: false,
        name: "newstatus",
        text: "New Workflow",
        isDisabled: false,
        id: 'oms_newstatus_btn',
    },
]

export const defaultOrderStatus = ["New", "Hold", "Rejected", "Accepted", "Packed", "Ready to Ship",
    "Intransit", "Out of Delivery", "Delivered", "Cancelled"];

export const actionValues = [
    { id: 1, key: 1, text: "Hold Inventory" },
    { id: 2, key: 2, text: "Allocate Inventory" },
    { id: 3, key: 3, text: "Release Inventory" },
    { id: 4, key: 4, text: "Generate Invoice" },
    { id: 5, key: 5, text: "Logistic Details" }
];

export const defaultActionsValidStates = [
    { selectActionKey: 1, selectAction: 'Hold Inventory', validStateValue: ["Accepted", "Hold", "Rejected", "Cancelled"], validStateKeys: [4, 2, 3, 10] },
    { selectActionKey: 0, selectAction: '', validStateValue: ["Accepted", "Rejected", "Cancelled"], validStateKeys: [4, 3, 10] },
    { selectActionKey: 3, selectAction: 'Release Inventory', validStateValue: [], validStateKeys: [] },
    { selectActionKey: 2, selectAction: 'Allocate Inventory', validStateValue: ["Packed", "Rejected"], validStateKeys: [5, 3] },
    { selectActionKey: 5, selectAction: 'Logistic Details', validStateValue: ['Ready to Ship', 'Accepted'], validStateKeys: [6, 4] },
    { selectActionKey: 4, selectAction: 'Generate Invoice', validStateValue: ['Intransit'], validStateKeys: [7] },
    { selectActionKey: 0, selectAction: '', validStateValue: ["Out of Delivery"], validStateKeys: [8] },
    { selectActionKey: 0, selectAction: '', validStateValue: ['Delivered'], validStateKeys: [9] },
    { selectActionKey: 0, selectAction: '', validStateValue: [], validStateKeys: [] },
    { selectActionKey: 3, selectAction: 'Release Inventory', validStateValue: [], validStateKeys: [] },
]


export const genConfigSaveObj = {
    "id": 0,
    "createdBy": localStorage.getItem('UserName') || 'John Wick',
    "createdDate": new Date(),
    "modifiedDate": new Date(),
    "modifiedBy": 'Ubooks',
    "orgCode": localStorage.getItem('OrgCode'),
    "isActive": true,
    "currencyCode": "1",
    "dateFormat": "2",
    "autoRoundOffTotals": false,
    "tdsadjustments": false,
    "otherAdjustments": false,
    "enableBarCode": false,
    "isAllowNegative": false,
    "enableBatch": false,
    "enableSerialization": false,
    "enableShelfLife": false,
    "enableVariantsBasedSku": false,
    "ecommerce": false,
    "isWarehouse": false,
    "trackInventory": false,
    "isMultiItemsInvoice": true,
    "activeTemplateId": 2, // default invoice template
    "isSaleOrderWfenabled": false,
  "isSaleReturnOrderWfenabled": false,
  "isPurchaseOrderWfenabled": false,
  "isPurchaseReturnOrderWfenabled": false,
  "isBarCodeEnabled": false,
  "enableMulticurrency":true,
}

export const businessType = [
    {
        typectrl: "txt",
        ctrltype: "text",
        termsHeight: "termScreen",
        label: "Business Type:",
        name: "businessType",
        isSpecialChar: false,
        value: '',
        type: "textarea",
        placeholder: "",
        isRequired: true,
        multiline: true,
        maxLength: 200,
        errormsg: false,
        noLabel : true
    },
    {
        typectrl: "txt",
        ctrltype: "btn",
        labels: "Update",
        type: "primary",
        text: "Update",
        disabled: false,
        id: "updateBtn",
    }
]
export const imagebtnData = [
    {
        typectrl: "txt",
        ctrltype: "btn",
        labels: "Save",
        type: "primary",
        text: "Save Image",
        disabled: false,
        id: "updateBtn",
        show:false,
    }  
]

